module.exports = __webpack_public_path__ + "img/sec_07.75a24ad7.png";